'use client'

import { useState, useEffect } from 'react'
import '@/styles/table.css'

interface PaginationBarProps {
  currentPage: number
  totalPages: number
  totalRecords: number
  pageSize: number
  onPageChange: (page: number) => void
  onScrollTop: () => void
  visible: boolean
}

export function PaginationBar({
  currentPage,
  totalPages,
  totalRecords,
  pageSize,
  onPageChange,
  onScrollTop,
  visible
}: PaginationBarProps) {
  const [inputPage, setInputPage] = useState(currentPage.toString())

  useEffect(() => {
    setInputPage(currentPage.toString())
  }, [currentPage])

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputPage(e.target.value)
  }

  const handleInputSubmit = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      const page = parseInt(inputPage)
      if (page >= 1 && page <= totalPages) {
        onPageChange(page)
      } else {
        setInputPage(currentPage.toString())
      }
    }
  }

  const handleInputBlur = () => {
    const page = parseInt(inputPage)
    if (page >= 1 && page <= totalPages) {
      onPageChange(page)
    } else {
      setInputPage(currentPage.toString())
    }
  }

  if (totalPages <= 1) return null

  return (
    <div className={`pagination-bar ${visible ? 'visible' : ''}`}>
      <div className="pagination-bar-inner">
        {/* İlk */}
        <button
          onClick={() => onPageChange(1)}
          disabled={currentPage === 1}
          className="pagination-btn"
        >
          İlk
        </button>

        {/* Önceki */}
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="pagination-btn"
        >
          Önceki
        </button>

        {/* Page Input */}
        <div className="pagination-input-wrapper">
          <input
            type="text"
            value={inputPage}
            onChange={handleInputChange}
            onKeyDown={handleInputSubmit}
            onBlur={handleInputBlur}
            className="pagination-input"
          />
          <span className="pagination-total">/ {totalPages}</span>
        </div>

        {/* Sonraki */}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="pagination-btn"
        >
          Sonraki
        </button>

        {/* Son */}
        <button
          onClick={() => onPageChange(totalPages)}
          disabled={currentPage === totalPages}
          className="pagination-btn"
        >
          Son
        </button>

        {/* Divider */}
        <div className="pagination-divider" />

        {/* Yukarı Çık */}
        <button
          onClick={onScrollTop}
          className="pagination-scroll-btn"
        >
          <i className="fa-solid fa-arrow-up"></i>
          Yukarı
        </button>
      </div>
    </div>
  )
}
